module.exports = __webpack_public_path__ + "img/v_3.90541dd9.svg";